const PUBLIC_RUNTIME_CONFIG_KEYS = [
  'APP_BASE_PATH',
  'LEGAL_BASE_PATH',
  'DASHBOARD_AUTH_HOST',
  'DASHBOARD_REDIRECT_HOST',
  'TEALIUM_SCRIPT_PATH',
  'NEXT_PUBLIC_EVENT_HORIZON_APP_NAME',
  'APPLY_FDR_URL',
  'LX_FDR_URL',
  'DASHBOARD_FDR_URL',
  'TRUSTPILOT_BUSINESS_ID',
  'TRUSTPILOT_NAME',
  'NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID',
  'NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN',
  'NEXT_PUBLIC_EVENT_HORIZON_TRACKER_URL',
  'INSIDER_SRC',
  'ZEMBRA_API_URL',
  'MS_CLARITY_KEY',
  'UPSCOPE_URL',
]

const getServerPublicRuntimeConfig = () => {
  const config = PUBLIC_RUNTIME_CONFIG_KEYS.reduce((values, key) => {
    values[key] = process.env[key]

    return values
  }, {})

  return {
    ...config,
    NEXT_PUBLIC_EVENT_HORIZON_DEBUG: process.env.APP_ENV !== 'prd',
    NEXT_PUBLIC_DATADOG_RUM_ENV: process.env.APP_ENV,
    NEXT_PUBLIC_APP_VERSION: process.env.DD_VERSION,
    IS_LOWER_ENV: /dev|stg|sbx/i.test(process.env.APP_ENV),
  }
}

export const PUBLIC_RUNTIME_CONFIG_ELEMENT_ID = '__FDR_PUBLIC_CONFIG__'

let cachedClientConfigSource
let cachedClientConfig = {}

const getClientPublicRuntimeConfig = () => {
  const source =
    document.getElementById(PUBLIC_RUNTIME_CONFIG_ELEMENT_ID)?.textContent ?? ''

  if (source !== cachedClientConfigSource) {
    cachedClientConfigSource = source
    try {
      cachedClientConfig = source ? JSON.parse(source) : {}
    } catch {
      cachedClientConfig = {}
    }
  }

  return cachedClientConfig
}

export const getPublicRuntimeConfig = () => {
  if (typeof window !== 'undefined') {
    return getClientPublicRuntimeConfig()
  }

  return getServerPublicRuntimeConfig()
}

const getRuntimeConfig = () => ({
  publicRuntimeConfig: getPublicRuntimeConfig(),
})

export const serializePublicRuntimeConfig = (config) =>
  JSON.stringify(config)
    .replace(/</g, '\\u003c')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')

export default getRuntimeConfig
